import React, { memo, useCallback, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Icon from "../assets/icons/Icon";

const Sidebar = () => {
  const [activeSections, setActiveSections] = useState({});
  const [tooltip, setTooltip] = useState({ show: false, text: "", x: 0, y: 0 });

  const location = useLocation();

  const toggleSection = useCallback((section) => {
    setActiveSections((prev) => ({ ...prev, [section]: !prev[section] }));
  }, []);

  useEffect(() => {
    setActiveSections({});
  }, [location.pathname]);

  const isCollapsed = () =>
    document.body.getAttribute("data-sidebar-size") === "collapsed";
  const isMobile = () => window.matchMedia("(max-width: 992px)").matches;
  const showTooltip = (e, text) => {
    if (!isCollapsed() || isMobile()) return;

    const rect = e.currentTarget.getBoundingClientRect();
    setTooltip({
      show: true,
      text,
      x: rect.right + 12,
      y: rect.top + rect.height / 2,
    });
  };
  const hideTooltip = () => setTooltip((p) => ({ ...p, show: false }));

  // safety: hide tooltip on route change
  useEffect(() => hideTooltip(), [location.pathname]);

  // safety: hide tooltip if screen resized to mobile
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 992px)");
    const onChange = () => {
      if (mq.matches) hideTooltip();
    };
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  const handleSideCollapsed = () => {
    const body = document.querySelector("body");
    const currentSize = body.getAttribute("data-sidebar-size");
    body.setAttribute("data-sidebar-size", "default");
  };

  return (
    <>
      <aside className="sidebar-cover">
        <ul className="firstUl">
          {[
            { to: "/live-market", icon: "LineChart", label: "Live Market" },
            { to: "/badla-rate", icon: "PieChart", label: "Badla Rate" },
            { to: "/manage-badla", icon: "BarChart3", label: "Manage Badla" },
          ].map(({ to, icon, label }) => (
            <li key={to} className="dropdown_box">
              <NavLink
                className={({ isActive }) =>
                  `sidebar_menu_font menu_card ${isActive ? "active" : ""}`
                }
                to={to}
                onMouseEnter={(e) => showTooltip(e, label)}
                onMouseLeave={hideTooltip}
                onClick={handleSideCollapsed}
              >
                <Icon name={icon} className="icon_sid" />
                <span className="sidebar_name">{label}</span>
              </NavLink>
            </li>
          ))}

          <li
            className={`dropdown_box ${activeSections.Accounts ? "open" : ""}`}
          >
            <Link
              className="sidebar_menu_font menu_card"
              onClick={() => toggleSection("Accounts")}
              onMouseEnter={(e) => showTooltip(e, "Accounts")}
              onMouseLeave={hideTooltip}
            >
              <Icon name="Briefcase" className="icon_sid" />
              <span className="sidebar_name">Accounts</span>
              <Icon name="ChevronDown" className="down_icon" />
            </Link>

            <ul
              className={`top_menu_open ${activeSections.Accounts ? "" : "d-none"}`}
            >
              {[
                { label: "Badla History", to: "/badla-history", icon: "Dot" },
                {
                  label: "Settlement List",
                  to: "/settlement-list",
                  icon: "Dot",
                },
                { label: "Summary", to: "/summary", icon: "Dot" },
              ].map(({ label, to, icon }) => (
                <li key={label}>
                  <Link
                    className="sidebar_open-box"
                    to={to}
                    onMouseEnter={(e) => showTooltip(e, label)}
                    onMouseLeave={hideTooltip}
                    onClick={handleSideCollapsed}
                  >
                    <Icon name={icon} className="icon_sid" />
                    <span className="sidebar_name">{label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </aside>

      {/* tooltip div kept */}
      <div
        className={`tooltip ${tooltip.show ? "show" : ""}`}
        style={{ left: tooltip.x, top: tooltip.y }}
      >
        {tooltip.text}
      </div>

      <div
        className="stratas-overlay d-print-none"
        onClick={handleSideCollapsed}
      ></div>
    </>
  );
};

export default memo(Sidebar);
